import { toast } from "sonner";
import { Copy } from "lucide-react";
import Playbook from "@/components/Playbook";
import { assembleSkoolMarkdown, blockToSkoolMarkdown } from "@/lib/skoolExport";

export default function AdminSkoolPlaybook() {
  const copyFullForSkool = async ({ blocks }) => {
    const generated = (blocks || []).filter((b) => (b?.body || "").trim().length > 0);
    if (generated.length === 0) {
      toast.error("Generate the playbook first — nothing to copy yet.");
      return;
    }
    const md = assembleSkoolMarkdown(blocks);
    try {
      await navigator.clipboard.writeText(md);
      toast.success("Playbook copied", {
        description: "Paste into Skool's About / Rules / Classroom / etc fields.",
      });
    } catch {
      toast.error("Copy failed — try again");
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const extraActions = ({ blocks }) => (
    <button
      type="button"
      onClick={() => copyFullForSkool({ blocks })}
      disabled={!(blocks || []).some((b) => (b?.body || "").trim())}
      data-testid="skool-copy-full-btn"      className="inline-flex items-center gap-2 rounded-md border border-[#7A8B6F] bg-[#7A8B6F] px-4 py-2 text-sm text-[#F5EFE2] transition-colors hover:bg-[#8B9C80] disabled:cursor-not-allowed disabled:opacity-40"
    >
      <Copy className="h-4 w-4" />
      Copy Full Playbook for Skool
    </button>
  );

  return (
    <Playbook
      kind="skool"
      eyebrow="Skool Setup"
      headline="Everything Skool asks for, already written."
      tagline="Ten copy-paste blocks in your voice — name, rules, welcome DMs, first-week posts. Lift them straight into Skool."
      emptyCTA="Generate the whole playbook"
      extraActions={extraActions}
      skoolFormatter={blockToSkoolMarkdown}
    />
  );
}
